/* eslint-disable indent */
import React, { Fragment } from "react";

import PropTypes from "prop-types";

import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import {
  isSuperAdmin,
  monthList,
  renderAccessLocation2,
  renderLocationFunction,
  yearList
} from "../../../constant/helper/helper";
import { toolTipData } from "./leaveData";
import Button from "../../../component/button/Button";
import SpinnerButton from "../../../component/spinner/SpinnerButton";

const TopInput = ({
  values,
  onChange,
  allLocations,
  currentUser,
  onGetLeave,
  hrLoading
}) => {
  const showMonthOptions = Object.values(monthList).map(
    (type, index) => (
      <option value={index + 1} key={index}>
        {type}
      </option>
    )
  );
  const showYearOptions = Object.values(yearList).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />
      <div className="col-lg-2 col-md-2 col-sm-12">
        <SelectInput2
          data-tip
          name="dataType"
          isLabeled={true}
          onChange={onChange}
          data-for="dataType"
          label="Select By"
          value={values.dataType}
          placeholder="Select Type"
          icon="mdi mdi-format-list-bulleted-type"
        >
          <option value="DATE">By Date</option>
          <option value="MONTH">By Month</option>
          <option value="ALL">ALL</option>
        </SelectInput2>
      </div>

      {values.dataType === "DATE" ? (
        <div className="col-lg-3 col-md-3 col-sm-12">
          <TextInput2
            data-tip
            type="date"
            name="date"
            data-for="date"
            onChange={onChange}
            value={values.date}
            placeholder="Select Date"
            icon="mdi mdi-calendar-check"
          />
        </div>
      ) : values.dataType === "MONTH" ? (
        <Fragment>
          <div className="col-lg-2 col-md-2 col-sm-12">
            <SelectInput2
              data-tip
              name="month"
              isLabeled={true}
              onChange={onChange}
              data-for="month"
              label="Select Month"
              value={values.month}
              placeholder="Select Month"
              icon="mdi mdi-calendar-multiple"
            >
              {showMonthOptions}
            </SelectInput2>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12">
            <SelectInput2
              data-tip
              name="year"
              isLabeled={true}
              onChange={onChange}
              data-for="year"
              label="Select Year"
              value={values.year}
              placeholder="Select Year"
              icon="mdi mdi-calendar-question"
            >
              {showYearOptions}
            </SelectInput2>
          </div>
        </Fragment>
      ) : null}

      <div className="col-lg-3 col-md-3 col-sm-12">
        <SelectInput2
          data-tip
          name="locationId"
          isLabeled={true}
          onChange={onChange}
          data-for="locationName"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
          icon="mdi mdi-map-marker-radius"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                JSON.parse(localStorage.getItem("selectedModule"))
              )}
        </SelectInput2>
      </div>
      <div className="col-lg-2 col-md-2 col-sm-12">
        <SelectInput2
          data-tip
          name="leaveFilter"
          isLabeled={true}
          onChange={onChange}
          data-for="leaveFilter"
          label="Select Type"
          value={values.leaveFilter}
          placeholder="Select Type"
          icon="mdi mdi-format-list-bulleted-type"
        >
          <option value="APPLIED">APPLIED</option>
          <option value="HOLD">HOLD</option>
          <option value="REJECTED">REJECTED</option>
          <option value="APPROVED">APPROVED</option>
        </SelectInput2>
      </div>

      {hrLoading ? (
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-lg-3 col-md-3 col-sm-12">
          <div className="form-group">
            <Button
              title="GET"
              type="button"
              onClick={onGetLeave}
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
    </div>
  );
};

TopInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onGetLeave: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired,
  hrLoading: PropTypes.bool.isRequired
};

export default TopInput;
